/**
 * Strings for sharing/meta data
 */

const sharingConfig = {
  defaultShareTextTwitter:
    "The State of European Tech 2017 is the deepest, data-led investigation into the European tech ecosystem - read it here:",
  defaultShareTextLinkedin:
    "The State of European Tech 2017 is the deepest, data-led investigation into the European tech ecosystem",
  defaultShareUrl: "http://www.stateofeuropeantech.com",
  linkedInSource: "Atomico",
  hashtags: "europeantech",
  shareImage:
    "https://2017.stateofeuropeantech.com/TheStateofEuropeanTech_2017.jpg"
};

export default sharingConfig;



// WEBPACK FOOTER //
// ./src/utils/sharingConfig.js